<template>
  <div>
    <b-row v-if="filter_toggle">
      <b-col>
        <b-row>
          <b-col>
            <b-form-group
              label="Filter"
              label-cols="1"
              label-align="right"
              label-for="filterInput"
              class="mb-0"
            >
              <b-input-group>
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">
                    Clear
                    <b-icon-x />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <br />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="option1 != null">
          <b-col>
            <b-form-group
              label="Tier"
              label-cols="2"
              label-align="right"
              class="mb-0"
            >
              <b-select v-model="filter1" :options="option1">
                <template v-slot:first>
                  <b-form-select-option value="">
                    View all
                  </b-form-select-option>
                </template>
              </b-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Region"
              label-cols="2"
              label-align="right"
              class="mb-0"
            >
              <b-select v-model="filter2" :options="option2">
                <template v-slot:first>
                  <b-form-select-option value="">
                    View all
                  </b-form-select-option>
                </template></b-select
              >
            </b-form-group>
            <br />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="2">
        <b-select v-model="perPage" :options="rows"></b-select>
      </b-col>
    </b-row>
    <!-- <b-button @click="toggleBusy">Toggle Busy State</b-button> -->
    <b-table
      v-if="(totalRows > 0) | (items.length > 0)"
      id="project_list"
      striped
      head-variant="light"
      hover
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter_string"
      @filtered="onFiltered"
      :selectable="selectable"
      :filter-function="filter_function"
      @row-selected="onRowSelected"
      ref="selectableTable"
      select-mode="multi"
      outlined
      sort-icon-left
      responsive
      :small="small"
    >
      <template #thead-top>
        <slot name="thead"></slot>
      </template>
      <template v-slot:head(public_id)>
        <b-checkbox
          v-if="selectable"
          ref="select_all"
          v-model="select_all"
          :indeterminate.sync="indeterminate"
          v-b-popover.hover.top-left="'Select / Deselect all'"
        >
        </b-checkbox>
        Actions
      </template>

      <template v-slot:cell(public_id)="data">
        <b-checkbox
          v-if="selectable"
          v-model="data.rowSelected"
          @change="toggleVisible(data.index, data.rowSelected)"
        />
        <span v-else>
          <b-link :href="`/project/${data.value}/edit`">
            <b-iconstack v-b-popover.hover.top="'Edit project'">
              <b-icon-square-fill variant="sgs-yellow" />
              <b-icon-pencil-square scale=".8" variant="white" />
            </b-iconstack>
          </b-link>

          <b-link
            v-b-modal.delete_object
            @click="input.selected_id = `${data.value}`"
          >
            <b-icon-x-square-fill
              v-b-popover.hover.top="'Delete project'"
              variant="danger"
            />
          </b-link>
        </span>
      </template>

      <template v-slot:cell(project_name)="data">
        <b-link :href="`/project/${data.item.public_id}`">
          {{ data.value }}
        </b-link>
      </template>

      <template v-slot:cell()="data">
        <span
          v-if="data.field.hasOwnProperty('format')"
          style="text-align: right"
        >
          {{ format_value(data.value, data.field.format) }}
        </span>
        <span v-else>
          {{ data.value }}
        </span>
      </template>
      <template v-slot:cell(attribute)="data">
        <span v-if="data.item.attribute != '0'">
          {{ data.value }}
        </span>
      </template>
    </b-table>
    <div v-else>
      <b-jumbotron class="text-center text-muted">
        <template v-slot:lead>
          There's nothing here yet. Get started by adding a project.
        </template>
      </b-jumbotron>
    </div>
    <br />

    <b-pagination
      v-if="(totalRows > perPage) & (perPage > 0)"
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      aria-controls="project_list"
      align="center"
    />

    <b-modal id="delete_object" centered no-stacking>
      <template v-slot:modal-title> Delete Project </template>
      <p>
        Are you sure you want to permanently delete this project?
        <br />All data associated with this project will also be deleted.
      </p>
      <template v-slot:modal-footer="{ cancel }">
        <b-col>
          <b-button variant="danger" @click="deleteObject" block>Yes</b-button>
        </b-col>
        <b-col>
          <b-button variant="primary" @click="cancel()" block>No</b-button>
        </b-col>
      </template>
    </b-modal>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import rows from "@/data/rows.json";

var numeral = require("numeral");

export default {
  name: "Table",
  props: {
    filter_toggle: { type: Boolean, default: true },
    selectable: Boolean,
    fields: { type: [Array, Object] },
    items: { type: [Array, Object] },
    object: String,
    option1: String,
    option2: String,
    small: { type: Boolean, default: false },
    perPage: { type: Number, default: 20 },
  },
  data() {
    return {
      rows,
      selected: [],
      isBusy: false,
      // perPage: this.perPageDefault,
      currentPage: 1,
      filter: "",
      totalRows: 0,
      filter1: "",
      filter2: "",
      select_all: false,
      indeterminate: true,
      // assessment
      assessment_input: {
        selected_id: "",
        report_year: null,
      },
      input: {
        selected_id: "",
      },
    };
  },
  methods: {
    toggleVisible(index, selected) {
      if (!selected) {
        if (this.select_all) {
          this.indeterminate = true;
        }
        this.$refs.selectableTable.unselectRow(index);
      } else {
        this.$refs.selectableTable.selectRow(index);
      }
      // this.onRowSelected(this.selected);
      // this.$emit("filter", this.selected);
    },
    onRowSelected(items) {
      this.selected = items;
      this.$emit("filter", this.selected);
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.selected = filteredItems;
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      this.indeterminate = true;
      this.$emit("filter", this.selected);
    },
    toggleBusy() {
      this.isBusy = !this.isBusy;
    },
    deleteObject(event) {
      event.preventDefault();
      this.$bvModal.hide("delete_object");
      this.$emit("deleteObject", this.input);
    },
    filter_function_nest(row, filter) {
      if (filter != "") {
        if (JSON.stringify(row).toLowerCase().includes(filter.toLowerCase())) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    filter_function(row, filter) {
      return (
        this.filter_function_nest(row, filter.text) &&
        this.filter_function_nest(row.company, filter.filter1) &&
        this.filter_function_nest(row.opportunity_owner, filter.filter2)
      );
    },
    format_value(value, format) {
      let valuestring = numeral(value).format(format);
      return valuestring.replace("NaN", "0");
    },
  },
  filters: {},
  computed: {
    filter_string() {
      let filter_string = {
        text: this.filter,
        filter1: this.filter1,
        filter2: this.filter2,
      };
      return filter_string;
    },
  },
  mounted() {
    console.log(this.items);
    this.totalRows = this.items.length;
  },
  updated() {
    this.totalRows = this.items.length;
  },
  watch: {
    select_all() {
      if (this.select_all) {
        this.$refs.selectableTable.selectAllRows();
      } else {
        this.$refs.selectableTable.clearSelected();
      }
    },
    selected() {
      if (this.selected.length == 0) {
        this.select_all = false;
      }
    },
    items() {
      this.totalRows = this.items.length;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.b-icon {
  margin-right: 0.3em;
}
.cell-head {
  font-size: 75%;
}
</style>
